import React, { Component } from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import Select from 'react-select';
import { Button, Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';

class StatisticsCurrenciesControl extends Component {
  state = {
    open: false,
    label: '',
    currency: '',
  };

  toggle = () => {
    this.setState(prevState => ({ open: !prevState.open }));
  };

  renderSelectNoResultsText = () => {
    const { intl } = this.props;
    return intl.formatMessage({
      id: 'statistics.filters.no-results-text',
      defaultMessage: 'No filters found',
    });
  };

  onChange = value => {
    this.toggle(); 
    this.props.onCurrencyChange(value);
  }

  render() {
    const {
      options,
      value,
      multiple,
      id,
      placement,
      name,
      currencies,
      onCurrencyChange,
      active,
    } = this.props;

    const { open } = this.state;
    const label = currencies[value];
    return (
      // <ButtonGroup className='currencies'>
      //   {currencies.length > 0 &&
      //     currencies.map((currency, index) => (
      //       <Button
      //         type="button"
      //         size="sm"
      //         color="primary"
      //         active={index === active}
      //         onClick={() => onCurrencyChange(index)}
      //         key={currency}
      //         outline
      //       >
      //         {currency}
      //       </Button>
      //     ))}
      // </ButtonGroup>

      <Dropdown isOpen={open} toggle={this.toggle} tag="span">
        <DropdownToggle
          onClick={this.toggle}
          data-toggle="dropdown"
          aria-expanded={open}
          tag="span"
        >
          <Button
            size="sm"
            color="light"
            active={open}
            id={id}
            onClick={this.toggle}
            outline
            className="statistics-filter-button btn-toggler"
          >
            {label}
            <i className="dropdown-toggle" />
            <span className="arrow" />
          </Button>
        </DropdownToggle>
        <DropdownMenu placement={placement} className="filter-popover">
          <Select
            options={options}
            onChange={({ value }) => this.onChange(value)}
            multi={false}
            value={value}
            noResultsText={this.renderSelectNoResultsText()}
            closeOnSelect={true}
            arrowRenderer={null}
            clearable={false}
            isSearchable={false}
            openOnFocus
            autoFocus
            alwaysOpened
          />
        </DropdownMenu>
      </Dropdown>
    );
  }
}

export default injectIntl(StatisticsCurrenciesControl);
